module.exports = __webpack_public_path__ + "assets/img/IE.616982f3.svg";